import { useCallback } from "react"
import { useToast } from "@hooks"
import { strategiesApi } from "Pages/DsRepricing/Page/@services/api"
import { fromServer } from "Pages/DsRepricing/Page/@services/adapters"
import { dsRepricingListData } from "Pages/DsRepricing/Page/@signals"

export default function useDsRepricingActions() {
	const { showToast } = useToast()

	const onDisable = useCallback((id, name) => {
		showToast.confirm(`Are you sure you want to disable '${name}'?`, {
			onSubmit: () => showToast.promise(
				strategiesApi.setStatus(id, 'disabled').then(fromServer),
				{
					onSuccess: (result) => {
						dsRepricingListData.value = dsRepricingListData.value.map(item =>
							item.id === id ? result : item
						)
					},
				}
			)
		})
	}, [])

	const onDelete = useCallback((id, name) => {
		showToast.confirm(`Are you sure you want to delete '${name}'? This action cannot be undone.`, {
			onSubmit: () => showToast.promise(
				strategiesApi.remove(id),
				{
					onSuccess: () => {
						dsRepricingListData.value = dsRepricingListData.value.filter(item => item.id !== id)
					},
				}
			)
		})
	}, [])

	return { onDisable, onDelete }
}